import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Table, Input, Button } from 'antd';
const store = [
  'devStore'
]
@inject(...store)
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'dev-apply-detailTable',
  }
  constructor(props) {
    super(props);
    this.state = {
      selectedRowKeys: [],
      dataSource: [],
      value: props.value || '',
    }
  }
  componentWillReceiveProps(nextProps) {
    const { value, appType, showData, devStore: { appDetail }, onChange } = nextProps;
    let dataSource = (value && value !== '[]' && value !== '') ? JSON.parse(value).map((v) => {
      return {
        ...v,
      }
    }) : [{
      key: 1,
      name: "入口",
      url: `/cloudstore/app/${toJS(appDetail).s_number}/index${appType === 'PC' ? '' : '-m'}.jsp`,
    }];
    if (!showData) dataSource = [];
    this.setState({ dataSource }, () => {
      const resValue = JSON.stringify(this.state.dataSource);
      if (value !== resValue) {
        this.setState({value: resValue}, () => {
          onChange && onChange(resValue);
        });
      }
    });
  }
  getColumns = (disabled) => {
    return [{
      title: '菜单名称',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        return (
          <Input value={text} disabled={disabled} onChange={e => this.onEdit(record, 'name', e.target.value)} />
        )
      }
    }, {
      title: 'URL地址',
      dataIndex: 'url',
      key: 'url',
      render: (text, record) => {
        return (
          <Input value={text} disabled={disabled} onChange={e => this.onEdit(record, 'url', e.target.value)} />
        )
      }
    }];
  }
  getHashId = () => {
    return Math.random().toString(36).substr(2, 6);
  }
  onRowSelection = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  }
  onAdd = () => {
    const { onChange } = this.props;
    const { dataSource } = this.state;
    this.setState({
      dataSource: [...dataSource, {
        key: this.getHashId(),
        name: '',
        url: '',
      }]
    }, () => {
      onChange && onChange(JSON.stringify(this.state.dataSource));
    });
  }
  onDel = () => {
    const { onChange } = this.props;
    const { selectedRowKeys, dataSource } = this.state;
    const result = dataSource.filter(v => selectedRowKeys.indexOf(v.key) < 0);
    this.setState({ dataSource: result, selectedRowKeys: [] }, () => {
      onChange && onChange(JSON.stringify(this.state.dataSource));
    });
  }
  onEdit = (record, key, value) => {
    const { onChange } = this.props;
    const { dataSource } = this.state;
    const result = dataSource.map(v => {
      if (record.key === v.key) {
        v[key] = value;
      }
      return v;
    });
    this.setState({ dataSource: result }, () => {
      onChange && onChange(JSON.stringify(this.state.dataSource));
    });
  }
  render() {
    const {
      prefixCls, className, disabled,
    } = this.props;
    const { selectedRowKeys, dataSource } = this.state;
    return (
      <div className={`${prefixCls} ${className}`}>
        {
          !disabled && (
            <div className={`${prefixCls}-btn`}>
              <Button size="small" type="primary" icon="plus" onClick={this.onAdd} />
              <Button size="small" icon="minus" disabled={selectedRowKeys.length === 0} onClick={this.onDel} />
            </div>
          )
        }
        <Table
          size="small"
          columns={this.getColumns(disabled)}
          dataSource={dataSource}
          rowSelection={disabled ? null :{
            selectedRowKeys,
            onChange: this.onRowSelection,
          }}
          pagination={false}
        />
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/dev/devApply/DetailTable.js